import {Button, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {useAsync2} from "nate-react-api-helpers";
import {api} from "../../../../api/API";
import {Loader} from "../../../../misc/Loader";
import {OutboundEmail} from "../../../../api/EmailQueue";
import moment from "moment";
import {timestampFormat} from "./Common";

export function EmailQueueItem(props: {
    id: number;
    onClose(): void;
}) {
    const info = useAsync2((input) => api.emailQueue.get(input),
        {id: props.id}, [props.id]);

    return (
        <Dialog2 open>
            <DialogTitle>
                Email Detail
            </DialogTitle>
            <DialogContent>
                <Loader<OutboundEmail> {...info}>
                    {d => (
                        <div>
                            <div>To: {d.recipients}</div>
                            <div>Reply To: {d.replyTo}</div>
                            <div>Subject: {d.subject}</div>
                            <div style={{paddingTop: 16}}>
                                <div dangerouslySetInnerHTML={d.bodyHtml ? {__html: d.bodyHtml} : undefined}>{d.bodyText}</div>
                            </div>
                            <div style={{paddingTop: 16}}>
                                {d.attachmentDetails?.map(a => <a href={api.files.downloadLink(a.file, "inline")}
                                    target="_blank">{a.name}</a>)}
                            </div>
                            <div>

                                <div>{d.sentAt ? `Sent at ${moment(d.sentAt).format(timestampFormat)}` : d.errorAt ? `Error at ${d.errorAt}: ${d.errorMessage}` : `Created at ${moment(d.createdAt).format(timestampFormat)}`}</div>
                                <div>Status: {d.sentAt ? "Sent" : d.errorAt ? "Failed" : "Pending"}</div>
                            </div>
                        </div>
                    )}
                </Loader>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.onClose()}>Close</Button>
            </DialogActions>
        </Dialog2>
    )
}